export default {
  title: 'Deliverect',
  form: {
    channel_link_id: {
      label: 'ID de ligação de canal: ',
    },
    store_id: {
      label: 'ID de localização externa: ',
    },
    store_provisioning_url: {
      label: 'URL de provisionamento da loja: ',
    },
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    error: 'Falha ao guardar alterações',
    success: 'Alterações guardadas',
  },
  instructions: {
    title: 'Instruções de configuração:',
    step_1:
      'Abra a página <Link>«Locations»</Link> no Deliverect, expanda a localização adequada e clique no botão «+ Channel link».',
    step_2:
      'Preencha as informações necessárias. No passo «Select your online delivery platform» selecione «Food Amigos».',
    step_3: 'Conclua todos os passos. Em seguida, na página «Locations», clique em «Edit» no canal «Food Amigos».',
    step_4: 'Na barra lateral, clique no separador «Channel connection» e preencha estes detalhes:',
    step_5: 'Guarde as alterações clicando no botão «Save» no canto superior direito.',
    step_6:
      'Após guardar, clique no ícone «More» no canto superior direito, depois em «Register» e de seguida em «Activate».',
    step_7: 'Volte ao separador «General», mude o «Integration status» para «Active» e guarde as alterações.',
    outro: 'Em seguida, pode enviar o menu do Deliverect e criar uma encomenda de teste.',
  },
  connected: {
    title: 'Deliverect está ligado',
    description: 'Esta integração está configurada.',
  },
};
